// Generated by scripts/sync-dgu-delivery-zones.mjs.
// Edit config/dgu-delivery-zones.json, then run the sync script.
(function (global) {
  "use strict";

  var FULL_AREAS = ["AL","BN","BR","CM","CO","CR","CT","DA","E","EC","EN","GU","HA","HP","IG","IP","KT","LU","MK","N","NW","OX","RG","RH","RM","SE","SG","SL","SM","SO","SS","SW","TN","TW","UB","W","WC","WD"];
  var OUTCODES = ["BH1","BH2","BH3","BH4","BH5","BH6","BH7","BH8","BH9","BH10","BH11","BH12","BH13","BH14","BH15","BH16","BH17","BH18","BH21","BH22","BH23","BH24","BH25","BH31","CB1","CB2","CB3","CB4","CB5","CB8","CB9","CB10","CB11","CB21","CB22","CB23","CB25","CV33","CV35","CV36","CV37","CV47","GL1","GL2","GL3","GL4","GL7","GL19","GL20","GL50","GL51","GL52","GL53","GL54","GL55","GL56","ME1","ME2","ME3","ME4","ME5","ME6","ME7","ME8","ME9","ME10","ME13","ME14","ME15","ME16","ME17","ME18","ME19","ME20","NN1","NN2","NN3","NN4","NN5","NN6","NN7","NN8","NN9","NN10","NN11","NN12","NN13","NN29","NR1","NR2","NR3","NR4","NR5","NR6","NR7","NR8","NR9","NR10","NR13","NR14","NR15","NR16","NR17","NR18","NR19","NR20","NR21","NR34","NR35","NR99","PO1","PO2","PO3","PO4","PO5","PO6","PO7","PO8","PO9","PO10","PO11","PO12","PO13","PO14","PO15","PO16","PO17","PO18","PO19","PO20","PO21","PO22","SN6","SN7","SN8","SP1","SP2","SP4","SP5","SP6","SP9","SP10","SP11","WR1","WR2","WR3","WR4","WR5","WR7","WR8","WR10","WR11","WR12","WR13","WR14"];

  function parsePostcode(postcode) {
    var cleaned = String(postcode || "").trim().toUpperCase().replace(/\s+/g, "");
    var match = cleaned.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/);
    if (!match) return null;
    return {
      postcode: match[1] + " " + match[2],
      outcode: match[1],
      area: (match[1].match(/^[A-Z]{1,2}/) || [""])[0]
    };
  }

  function match(postcode) {
    var parsed = parsePostcode(postcode);
    return Boolean(parsed && (
      FULL_AREAS.indexOf(parsed.area) !== -1 ||
      OUTCODES.indexOf(parsed.outcode) !== -1
    ));
  }

  global.GlassShopDguDeliveryZones = Object.freeze({
    version: "2026-07-30",
    status: "provisional-pending-ryan-confirmation",
    chargeExVatPence: 4000,
    chargeIncVatPence: 4800,
    title: "DGU delivery",
    fullAreas: Object.freeze(FULL_AREAS.slice()),
    outcodes: Object.freeze(OUTCODES.slice()),
    parsePostcode: parsePostcode,
    match: match
  });
})(window);
